import { ParamMap, UrlTree } from '@angular/router';

export function areSegmentsEqual(prevUrlTree: UrlTree, currUrlTree: UrlTree): boolean {
  const prevSegments = prevUrlTree?.root?.children?.primary?.segments;
  const currSegments = currUrlTree?.root?.children?.primary?.segments;
  return (
    prevSegments?.length === currSegments?.length &&
    prevSegments.every((prevSegment, index) => prevSegment.path === currSegments[index].path)
  );
}

export function areQueryParamMapEqual(prevQueryParams: ParamMap, currQueryParams: ParamMap, field: string): boolean {
  return (
    (prevQueryParams.has(field) &&
      currQueryParams.has(field) &&
      prevQueryParams.get(field) === currQueryParams.get(field)) ||
    (!prevQueryParams.has(field) && !currQueryParams.has(field))
  );
}

export function areAllQueryParamMapEqual(
  prevQueryParams: ParamMap,
  currQueryParams: ParamMap,
  fields: string[]
): boolean {
  return fields.every((field) => areQueryParamMapEqual(prevQueryParams, currQueryParams, field));
}

export function areTargetsEqual(prevUrlTree: UrlTree, currUrlTree: UrlTree): boolean {
  const prevQueryParams = prevUrlTree.queryParamMap;
  const currQueryParams = currUrlTree.queryParamMap;
  return areQueryParamMapEqual(prevQueryParams, currQueryParams, 'target');
}

export function areQueryEqual(prevUrlTree: UrlTree, currUrlTree: UrlTree): boolean {
  const prevQueryParams = prevUrlTree.queryParamMap;
  const currQueryParams = currUrlTree.queryParamMap;
  return areQueryParamMapEqual(prevQueryParams, currQueryParams, 'query');
}

export function areCurrentPageEqual(prevUrlTree: UrlTree, currUrlTree: UrlTree): boolean {
  const prevQueryParams = prevUrlTree.queryParamMap;
  const currQueryParams = currUrlTree.queryParamMap;
  return areQueryParamMapEqual(prevQueryParams, currQueryParams, 'currentPage');
}

export function getDomain(host: string): string {
  const splitHost = host.split('.');
  const isDoubleExtension = ['co', 'com'].includes(splitHost[splitHost.length - 2]);
  const sliceSize = isDoubleExtension ? -3 : -2;
  return splitHost.slice(sliceSize).join('.');
}
